import { useMemo } from 'react';
import { Person } from '../../../types/people';
import { InitialsAvatar } from '../../shared';
import { TableColumn } from '../../shared/table';
import moment from 'moment';

export const usePeopleTableConfig = (): TableColumn<Person>[] => {
  return useMemo<TableColumn<Person>[]>(() => [
    {
      header: 'Name',
      width: '250px',
      renderCell: (person) => (
        <div className="flex items-center">
          <div className="mr-3">
            <InitialsAvatar 
              personId={person.id} 
              name={`${person.firstName} ${person.lastName}`}
              avatarUrl={person.avatarUrl}
            />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold">
              {person.firstName} {person.lastName}
            </span>
            {person.email && (
              <span className="text-xs text-gray-500">{person.email}</span>
            )}
          </div>
        </div>
      ),
    },
    {
      header: 'Phone Number',
      width: '140px',
      renderCell: (person) => <span className="text-sm">{person.phoneNumber}</span>,
    },
    {
      header: 'Address',
      width: '250px',
      flexGrow: true,
      allowWrap: true,
      renderCell: (person) => (
        <span className="text-sm line-clamp-2">
          {person.address}
        </span>
      ),
    },
    {
      header: 'Most Recent Gift',
      width: '200px',
      renderCell: (person) => {
        if (!person.mostRecentGift) {
          return <span className="text-xs text-gray-400">No gifts</span>;
        }
        const { amount, date, fund } = person.mostRecentGift;
        const formattedDate = moment(date).format('MMM D, YYYY');
        return (
          <div className="flex flex-col gap-1 overflow-hidden">
            <span className="font-semibold text-sm text-green-600">
              ${amount.toLocaleString()}
            </span>
            <span className="text-xs text-gray-600 truncate">
              {formattedDate} • {fund}
            </span>
          </div>
        );
      },
    },
    {
      header: 'Updated',
      width: '120px',
      renderCell: (person) => <span className="text-sm">{moment(person.lastUpdated).format('MMM D, YYYY')}</span>
    },
  ], []);
};
